/** A chat bubble from the page assistant. */
const AssistantBubble = ({ text }: { text: string }) => (
  <p className="rounded-2xl rounded-bl-sm bg-grey-95 px-3 py-2 text-sm text-grey-20 dark:bg-primary-20 dark:text-white">
    {text}
  </p>
);

export default AssistantBubble;
